exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-27fd39d1] .el-card__header {\n  background: #f5f7fa;\n}\n.info[data-v-27fd39d1] {\n  color: #ccc;\n}\n.card-header[data-v-27fd39d1] {\n  height: 40px;\n  line-height: 40px;\n}\n.inputs[data-v-27fd39d1] {\n  width: 80%;\n}\n.radio-wrapper[data-v-27fd39d1] {\n  padding-top: 10px;\n}\n.radio-wrapper .el-radio[data-v-27fd39d1] {\n    margin-bottom: 10px;\n}\n", ""]);

// exports
